<template>
  <el-dialog 
    class="mail-list-dialog"
    width="1200px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :show-close="false"
    :visible.sync="visible">
    <div class="dialog-close" @click="handleClose"></div>
    <div class="dialog-title">订单编号：{{ currentDemandSn || '-' }} 需邮寄物料清单</div>
    <div class="dialog-header" >
      <div class="tab-wrapper" v-if="showTabs">
        <div
          class="tab-item"
          :class="{ active: activeTab === 'bom' }"
          @click="handleTabChange('bom')"
        >BOM明细</div>
        <div
          class="tab-item"
          :class="{ active: activeTab === 'replenish' }"
          @click="handleTabChange('replenish')"
        >补料明细</div>
      </div>
      <div class="action-wrapper">
        <div class="download-btn" @click="handleDownload"><i class="el-icon-download"></i>下载邮寄清单</div>
      </div>
    </div>
    <!-- 单号Tab：仅在补料明细下显示 -->
    <div class="order-sn-tabs" v-if="showTabs && activeTab === 'replenish' && replenishOrderSns.length > 0">
      <div class="tab-wrapper">
        <div
          v-for="sn in replenishOrderSns"
          :key="sn"
          class="tab-item"
          :class="{ active: activeOrderSn === sn }"
          @click="handleOrderSnChange(sn)"
        >{{ sn }}</div>
      </div>
    </div>
    <el-table
      ref="materialTable"
      class="mail-list-table"
      :data="currentTableData"
      border
      size="small"
      :cell-style="cellStyle"
      max-height="500"
    >
      <el-table-column
        width="55"
      >
        <template slot="header" slot-scope="scope">
          <div class="custom-selection">
            <el-checkbox 
              v-model="selectAll" 
              @change="handleSelectAll"
              :disabled="isSelectAllDisabled"
            ></el-checkbox>
          </div>
        </template>
        <template slot-scope="{ row, $index }">
          <div class="custom-selection">
            <el-checkbox 
              v-model="row.selected" 
              @change="() => handleRowSelect(row)" 
              :disabled="isOperationDisabled(row)"
            >{{ $index + 1 }}</el-checkbox>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="我的需求"
      >
        <template slot-scope="{ row }">
          <mailListItem :text="`【${row.cusGoodsName || '-'}】【${row.cusSpecification || '-'}】【${row.cusEncapsulation || '-'}】【${row.cusGoodsBrand || '-'}】`" :showDelete="row.isDeleted" :isDisabled="row.isDeleted"/>
        </template>
      </el-table-column>
      <el-table-column
        label="型号"
        width="80"
      >
        <template slot-scope="{ row }">
          <mailListItem :text="row.displayName" :isDisabled="row.isDeleted"/>
        </template>
      </el-table-column>
      <el-table-column
        label="品牌"
        width="75"
      >
        <template slot-scope="{ row }">
          <mailListItem :text="row.displayBrand" :isDisabled="row.isDeleted"/>
        </template>
      </el-table-column>
      <el-table-column label="封装" width="75" >
        <template slot-scope="{ row }">
          <mailListItem :text="row.displayEncapsulation" :isDisabled="row.isDeleted"/>
        </template>
      </el-table-column>
      <el-table-column label="规格参数" width="75" >
        <template slot-scope="{ row }">
          <mailListItem :text="row.displaySpecification" :isDisabled="row.isDeleted"/>
        </template>
      </el-table-column>
      <el-table-column label="物料编号" width="85" >
        <template slot-scope="{ row }">
          <el-tooltip 
            v-if="row.isReviewing" 
            :content="REVIEW_STATUS.TOOLTIP" 
            placement="top"
          >
            <span class="reviewing-text">{{ REVIEW_STATUS.TEXT }}</span>
          </el-tooltip>
          <el-tooltip
            v-else-if="row.isTempCode"
            content="临时编码，资料创建后生成G开头编码"
            placement="top"
          >
            <mailListItem :text="row.displayCode" :isDisabled="row.isDeleted"/>
          </el-tooltip>
          <mailListItem v-else :text="row.displayCode" :isDisabled="row.isDeleted"/>
        </template>
      </el-table-column>
      <el-table-column label="贴片总数量" width="85" >
        <template slot-scope="{ row }">
          <mailListItem :text="row.totalNumber || 0" :isDisabled="row.isDeleted"/>
        </template>
      </el-table-column>
      <el-table-column label="订单占用数量" width="95" >
        <template slot-scope="{ row }">
          <mailListItem :text="row.occupyNumber || 0" :isDisabled="row.isDeleted"/>
        </template>
      </el-table-column>
      <el-table-column label="已添加邮寄数量" width="105" >
        <template slot-scope="{ row }">
          <mailListItem :text="row.alreadyAddedQty" :isDisabled="row.isDeleted"/>
        </template>
      </el-table-column>
      <el-table-column label="剩余邮寄数量" width="95" >
        <template slot-scope="{ row }">
          <mailListItem :text="row.remainingQty" textColor="red" :isDisabled="row.isDeleted"/>
        </template>
      </el-table-column>
      <el-table-column label="已入库数量"  width="90" >
        <template slot-scope="{ row }">
          <mailListItem :text="row.inStockNumber || 0" :isDisabled="row.isDeleted"/>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="95" >
        <template slot-scope="{ row }">
          <mailListOperation
            :disabled="isOperationDisabled(row)"
            :is-deleted="row.isDeleted"
            :title="getOperationDisabledTitle(row)"
            @click="handleAddToMail(row)"
          />
        </template>
      </el-table-column>
    </el-table>
    <div class="dialog-footer">
      <div class="selected-info">已选中{{ selectedCount }}种元器件</div>
      <div class="btn-wrapper">
        <div  class="btn-primary" @click="jumpToShippingPage()">前往邮寄列表</div>
        <div class="btn-primary" @click="handleDirectMail"><i class="el-icon-plus"></i>直接新建一个包裹邮寄</div>
        <div class="btn-default" @click="handleBatchAdd">批量添加到邮寄列表</div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import mailListItem from "./components/mail-list-item.vue"
import mailListOperation from "./components/mail-list-operation.vue"
import { getMailMaterialList, addToMailList } from "@@/api/pcba.js"
import { isPcbSite, isSmtSite } from "@@/utils/is"
import { targetSelfWindow } from "@@/utils/triggerParent"
import { sortByMaterialsType ,sub } from "@@/utils/utils"
import CONFIG from "@@/config"

// 常量定义
const MAILING_TYPE = {
  SINGLE: 'single',           // 单个添加
  BATCH_LIST: 'batch-list',   // 批量添加到列表
  BATCH_PACKAGE: 'batch-package' // 批量添加到包裹
}

const MAILING_MESSAGES = {
  NO_SELECTED: '请勾选邮寄物料',
  NO_REMAINING: '没有待邮寄的器件',
  NO_MATERIAL: '暂无邮寄物料'
}

// 审核状态常量（DRY原则：统一管理审核状态文案）
const REVIEW_STATUS = {
  TEXT: '资料审核中',
  TOOLTIP: '预计BOM完成报价后生成物料编码'
}

// 添加方式参数策略映射（避免if/else）
const ADD_TYPE_STRATEGIES = {
  [MAILING_TYPE.SINGLE]: { addType: 0 },
  [MAILING_TYPE.BATCH_LIST]: { addType: 0 },
  [MAILING_TYPE.BATCH_PACKAGE]: { addType: 1 }
}

// 订单类型参数策略映射（避免if/else）
const ORDER_TYPE_PARAM_STRATEGIES = {
  bom: () => ({ addOrderType: 0, sourceSecondSn: '' }),
  replenish: (activeOrderSn) => ({ addOrderType: 1, sourceSecondSn: activeOrderSn })
}

export default {
  name: "mail-list-dialog",
  components: {
    mailListItem,
    mailListOperation
  },
  props: {
    demandSn: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      currentDemandSn: '', // 当前订单编号
      activeTab: 'bom', // 当前激活的tab: 'bom' 或 'replenish'
      tableData: [], // BOM明细数据
      replenishData: [], // 补料明细数据
      hasReplenishData: false, // 是否存在补料数据（控制所有Tab的显示/隐藏）
      activeOrderSn: '', // 当前选中的补料单号
      replenishOrderMap: {}, // 补料数据按sourceSecondSn分组的映射表
      replenishOrderSns: [], // 补料单号列表
      selectAll: false,
      selectedCount: 0,
      REVIEW_STATUS // 审核状态常量（暴露给模板使用）
    }
  },
  computed: {
    // 是否显示Tab区域
    showTabs() {
      return this.hasReplenishData
    },
    // 是否来自 mycenter（通过路由判断）
    isFromMycenter() {
      return location.pathname.includes('/mycenter')
    },
    // 是否显示"前往邮寄列表"按钮（非 mycenter 来源时显示）
    showShippingButton() {
      return !this.isFromMycenter
    },
    // 当前tab对应的表格数据
    currentTableData() {
      if (this.activeTab === 'bom') {
        return this.tableData
      }
      // 补料明细：根据当前选中的单号返回对应数据
      return this.replenishOrderMap[this.activeOrderSn] || []
    },
    // 全选复选框是否禁用
    isSelectAllDisabled() {
      // 如果没有数据或所有行都不可选，则禁用全选
      return !this.currentTableData.length || !this.currentTableData.some(row => this.isRowSelectable(row))
    }
  },
  watch: {
    // 监听表格数据变化，强制取消禁用行的选中状态
    currentTableData: {
      immediate: true,
      handler(rows) {
        if (!rows || rows.length === 0) return
        rows.forEach(row => {
          if (row.selected && !this.isRowSelectable(row)) {
            row.selected = false
          }
        })
        // 重新计算全选状态和选中数量
        const selectableRows = rows.filter(row => this.isRowSelectable(row))
        this.selectAll = selectableRows.length > 0 && selectableRows.every(row => row.selected)
        this.updateSelectedCount()
      }
    }
  },
  methods: {
    handleClose() {
      this.visible = false
    },
    // 加载邮寄物料数据（分离出来供复用）
    async loadData(demandSn) {
      if (!demandSn) {
        this.$message.warning('需求单号不能为空')
        return false
      }
      
      try {
        const res = await getMailMaterialList({ demandSn })
        if (res.retCode === 0) {
          this.rawData = res.result || []
          this.processTableData()
          return true
        }
        return false
      } catch (err) {
        console.error('获取邮寄物料清单失败:', err)
        return false
      }
    },
    async openDialog(demandSn) {
      if (!demandSn) {
        this.$message.warning('需求单号不能为空')
        return
      }

      this.visible = true
      this.currentDemandSn = demandSn || ''
      // 重置选中状态
      this.selectAll = false
      this.selectedCount = 0
      
      await this.loadData(demandSn)
    },
    // 处理接口返回的数据
    processTableData() {
      // 保存当前选中的单号（刷新时保持选中状态）
      const savedOrderSn = this.activeOrderSn

      // 重置状态
      this.tableData = []
      this.replenishOrderMap = {}
      this.replenishOrderSns = []
      this.hasReplenishData = false
      this.activeOrderSn = ''

      if (!this.rawData || this.rawData.length === 0) {
        return
      }

      // 订单类型处理器映射（策略模式）
      const orderTypeHandlers = {
        0: this.handleDemandOrder.bind(this),
        1: this.handleReplenishOrder.bind(this)
      }

      // 遍历所有单据，按类型分发处理
      this.rawData.forEach(orderItem => {
        const handler = orderTypeHandlers[orderItem.materialOrderType]
        if (handler) {
          handler(orderItem)
        }
      })

      // 设置是否有补料数据
      this.hasReplenishData = this.replenishOrderSns.length > 0

      // 恢复之前选中的单号（如果还存在），否则选中第一个
      if (this.hasReplenishData && this.replenishOrderSns.length > 0) {
        this.activeOrderSn = this.replenishOrderSns.includes(savedOrderSn)
          ? savedOrderSn
          : this.replenishOrderSns[0]
      }
    },
    // 处理需求单数据（materialOrderType = 0）
    handleDemandOrder(orderItem) {
      const processedRows = this.processMaterialRows(orderItem.materialList || [], orderItem.afterId)
      this.tableData = this.tableData.concat(processedRows)
    },
    // 处理补料单数据（materialOrderType = 1）
    handleReplenishOrder(orderItem) {
      const sourceSecondSn = orderItem.sourceSecondSn || '-'
      const processedRows = this.processMaterialRows(orderItem.materialList || [], orderItem.afterId)

      // 按 sourceSecondSn 分组存储
      if (!this.replenishOrderMap[sourceSecondSn]) {
        this.replenishOrderMap[sourceSecondSn] = []
        this.replenishOrderSns.push(sourceSecondSn)
      }
      this.replenishOrderMap[sourceSecondSn] = this.replenishOrderMap[sourceSecondSn].concat(processedRows)
    },
    // 通用物料行处理（DRY原则：统一的过滤、排序、衍生字段计算）
    processMaterialRows(materialList, afterId) {
      // 不再过滤删除行，所有物料都显示
      let filteredList = [...materialList]

      // 使用公共排序函数：PCB 置顶（materialsType === 1）
      filteredList = sortByMaterialsType(filteredList)

      // 计算衍生字段
      return filteredList.map(item => {
        const alreadyAddedQty = item.alreadyMailedNumber || 0
        const remainingQty = item.mailingNumber 
        const isDeleted = item.materialsItemStatus === 99
        const isReviewing = !item.goodsCode // 物料编号为空时表示资料审核中

        // 字段映射逻辑：与 materialFieldMapper.js 保持一致
        const useStandardFields = item.goodsCode && item.goodsName
        const displayCode = item.goodsCode ? item.goodsCode : '-'
        const isTempCode = item.goodsCode && !item.goodsCode.startsWith('G') // 存在物料编码但不是G开头，表示临时编码
        const displayName = useStandardFields ? item.goodsName : (item.cusGoodsName || '-')
        const displayBrand = useStandardFields ? item.goodsBrand : (item.cusGoodsBrand || '-')
        const displayEncapsulation = useStandardFields ? item.encapsulation : (item.cusEncapsulation || '-')
        const displaySpecification = useStandardFields ? item.specification : (item.cusSpecification || '-')

        return {
          ...item,
          selected: false,
          alreadyAddedQty,
          remainingQty,
          isDeleted, // 业务状态：物料是否被删除
          isReviewing, // 资料审核中状态
          isTempCode, // 是否为临时编码（存在但不是G开头）
          afterId: afterId || 0, // 携带所属订单的afterId
          displayCode,
          displayName,
          displayBrand,
          displayEncapsulation,
          displaySpecification,
        }
      })
    },
    // 生成随机码（无匹配结果时使用）
    generateRandomCode() {
      const timestamp = Date.now().toString(36)
      const random = Math.random().toString(36).substr(2, 5)
      return `R${timestamp}${random}`.toUpperCase()
    },
    // 判断操作按钮是否禁用（策略模式：统一禁用逻辑）
    isOperationDisabled(row) {
      return row.isReviewing || row.isDeleted || row.remainingQty <= 0
    },
    // 获取操作按钮禁用提示文案（DRY原则：统一管理提示文案）
    getOperationDisabledTitle(row) {
      if (row.isDeleted) return '物料已删除'
      if (row.isReviewing) return REVIEW_STATUS.TOOLTIP
      if (row.remainingQty <= 0) return MAILING_MESSAGES.NO_REMAINING
      return ''
    },
    // 获取选中的有效物料（排除已删除的）
    getSelectedItems() {
      return this.currentTableData.filter(row => row.selected && !row.isDeleted)
    },
    // 自定义单元格样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 删除且已添加数量为0的行，背景置灰
      const isDel = row.isDeleted && row.alreadyAddedQty <= 0
      if (isDel) {
        return {
          background: '#F6F6F6',
        }
      }
      return {}
    },
    // 判断行是否可选（策略模式：与isOperationDisabled保持一致）
    isRowSelectable(row) {
      return !this.isOperationDisabled(row)
    },
    // 全选/取消全选
    handleSelectAll() {
      this.currentTableData.forEach(row => {
        // 不可选的行不能被选中
        if (this.isRowSelectable(row)) {
          row.selected = this.selectAll
        }
      })
      this.updateSelectedCount()
    },
    // 单行选择变化
    handleRowSelect(row) {
      // 强制取消不可选行的选中状态（防止disabled未生效时仍能点击）
      if (!this.isRowSelectable(row)) {
        row.selected = false
      }
      // 检查是否所有可选行都被选中
      const selectableRows = this.currentTableData.filter(row => this.isRowSelectable(row))
      this.selectAll = selectableRows.every(row => row.selected)
      this.updateSelectedCount()
    },
    // 更新已选中数量
    updateSelectedCount() {
      this.selectedCount = this.currentTableData.filter(row => row.selected).length
    },
    // 下载邮寄清单
    handleDownload() {
      // 触发事件通知父组件打开DownList弹窗
      this.$emit('download-list', this.currentDemandSn)
    },
    // tab切换
    handleTabChange(tab) {
      this.activeTab = tab
      // 重置选中状态
      this.selectAll = false
      this.selectedCount = 0

      // 切换到补料明细时，默认选中第一个单号
      if (tab === 'replenish' && this.replenishOrderSns.length > 0) {
        this.activeOrderSn = this.replenishOrderSns[0]
      }
    },
    // 单号切换
    handleOrderSnChange(sn) {
      this.activeOrderSn = sn
      // 重置选中状态
      this.selectAll = false
      this.selectedCount = 0
    },
    // 构造添加到邮寄列表的基础参数（策略模式避免if/else）
    buildMailBaseParams(firstSelectedItem) {
      const strategy = ORDER_TYPE_PARAM_STRATEGIES[this.activeTab]
      return {
        demandSn: this.currentDemandSn,
        afterId: firstSelectedItem.afterId || 0,
        ...strategy(this.activeTab === 'replenish' ? this.activeOrderSn : '')
      }
    },
    // 执行添加到邮寄列表的公共逻辑（DRY原则）
    async executeAddToMail(type, items, needJump = false) {
      if (items.length === 0) {
        this.$message.warning(MAILING_MESSAGES.NO_SELECTED)
        return false
      }
      
      const addTypeStrategy = ADD_TYPE_STRATEGIES[type]
      const params = {
        ...this.buildMailBaseParams(items[0]),
        ...addTypeStrategy,
        materialsItemIdList: items.map(item => item.customerMaterialsItemId).filter(Boolean)
      }
      return this.callAddToMailList(params, needJump)
    },
    // 调用添加到邮寄列表接口
    async callAddToMailList(params, needJump = false) {
      try {
        const res = await addToMailList(params)
        if (res.retCode === 0) {
          this.$message.success('添加成功')
          if (needJump) {
            // 从接口返回结果中获取 mailingPackageId
            const mailingPackageId = res.result
            // 批量操作需要跳转页面，携带 mailingPackageId
            this.jumpToShippingPage(mailingPackageId)
          } else {
            // 单个添加只需刷新当前弹窗数据
            await this.loadData(this.currentDemandSn)
          }
          return true
        }
        this.$message.error(res.retMsg || '添加失败')
        return false
      } catch (err) {
        console.error('添加到邮寄列表失败:', err)
        this.$message.error('添加失败，请稍后重试')
        return false
      }
    },
    // 跳转到待邮寄页面（参考 index.vue handleOrder 的跳转逻辑）
    jumpToShippingPage(mailingPackageId) {
      // 直接构建完整路径
      const fullPath = mailingPackageId 
        ? `/mycenter/steward/myShipping?mailingPackageId=${mailingPackageId}`
        : '/mycenter/steward/myShipping'
      
      if (isPcbSite) {
        // PCB 站点：直接跳转
        location.href = fullPath
      } else if (isSmtSite) {
        // SMT 站点：拼接完整 URL
        location.href = `${CONFIG.HQCHIP_HOST}${fullPath}`
      } else {
        // 其他站点：使用 router 跳转，携带 query 参数（不关闭当前标签）
        this.$router.push({
          path: '/steward/myShipping',
          query: mailingPackageId ? { mailingPackageId } : {}
        })
      }
    },
    // 单个添加到待邮寄（刷新弹窗）
    async handleAddToMail(row) {
      if (this.isOperationDisabled(row)) {
        this.$message.warning(MAILING_MESSAGES.NO_REMAINING)
        return
      }
      await this.executeAddToMail(MAILING_TYPE.SINGLE, [row], false)
    },
    // 批量添加到待邮寄（跳转页面）
    async handleBatchAdd() {
      const selectedItems = this.getSelectedItems()
      await this.executeAddToMail(MAILING_TYPE.BATCH_LIST, selectedItems, true)
    },
    // 直接新建包裹邮寄（跳转页面）
    async handleDirectMail() {
      const selectedItems = this.getSelectedItems()
      // 校验是否勾选
      if (selectedItems.length === 0) {
        this.$message.warning(MAILING_MESSAGES.NO_SELECTED)
        return
      }
      await this.executeAddToMail(MAILING_TYPE.BATCH_PACKAGE, selectedItems, true)
    }
  }
}
</script>

<style lang="scss" scoped>
.mail-list-dialog {
  ::v-deep .el-dialog__header {
    padding: 0;
  }
  ::v-deep .el-dialog__body {
    padding: 24px;
  }
  .dialog-title {
    margin-bottom: 8px;
    font-weight: bold;
    font-size: 18px;
    color: #000000;
  }
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
  ::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #CC0000;
    border-color: #CC0000;
  }
  ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #333333;
  }
  ::v-deep .custom-selection .el-checkbox__label {
    color: #333333;
    padding-left: 4px;
  }
  ::v-deep .el-checkbox__inner:hover {
    border-color: #CC0000;
  }
  ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #CC0000;
  }
  .custom-selection {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .dialog-close {
    position: absolute;
    top: 24px;
    right: 24px;
    width: 24px;
    height: 24px;
    background-image: url(~@@/assets/img/common/dialog-close.png);
    background-repeat: no-repeat;
    background-size: 100%;
    cursor: pointer;
  }

  .order-sn-tabs {
    padding-bottom: 20px;
  }
  .tab-wrapper {
      display: flex;
      flex: 1;

      .tab-item {
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        color: #333333;
        margin-right: 46px;
        cursor: pointer;
        user-select: none;
        &:hover {
          color: #cc0000;
        }

        &.active {
          position: relative;
          color: #cc0000;
          font-weight: 700;
          &::after {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-15px);
            content: '';
            width: 30px;
            height: 3px;
            background: #cc0000;
            border-radius: 2px;
          }
        }

      }
    }

    .action-wrapper {
      margin-left: auto;
      .download-btn {
        font-size: 12px;
        color: #666666;
        cursor: pointer;
        user-select: none;
        .el-icon-download {
          margin-right: 4px;
          font-size: 16px;
          display: inline-block;
        }
      }
    }
  .dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    padding-bottom: 12px;

  
  }

  .el-table {
    margin-bottom: 16px;
  }

  .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .selected-info {
      font-size: 14px;
      color: #666666;
    }

    .btn-wrapper {
      display: flex;

      .btn-primary {
        width: 199px;
        height: 40px;
        background: #ffffff;
        border: 1px solid #f5cccc;
        border-radius: 4px;
        box-sizing: border-box;
        font-size: 14px;
        text-align: center;
        color: #cc0000;
        line-height: 40px;
        user-select: none;
        cursor: pointer;
        margin-right: 16px;
        i {
          display: inline-block;
          font-weight: bold;
          margin-right: 4px;
        }
      }

      .btn-default {
        width: 170px;
        height: 40px;
        background: #cc0000;
        border-radius: 4px;
        font-size: 14px;
        text-align: center;
        color: #ffffff;
        line-height: 40px;
        user-select: none;
        cursor: pointer;
      }
    }
  }
}
.mail-list-table {
  ::v-deep th.el-table__cell {
    background: #fafafa;
    color: #666666;
  }
}

// 审核中文字样式（DRY原则：统一审核状态样式）
.reviewing-text {
  color: #CC0000;
  font-weight: 500;
}
</style>
